var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    largePrimaryButton: true,
    largePrimaryButtonFlat: !!_vm.flat,
    largePrimaryButtonRounded: !_vm.flat,
    bottomActionButton: !!_vm.bottomActionButton,
    largePrimaryButtonActive: _vm.active,
  },on:{"click":_vm.onClick}},[_vm._v("\n  "+_vm._s(_vm.text)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }